export const JSON_URL = process.env.GATSBY_WORDPRESS_URL;
export const EWAY_KEY = process.env.GATSBY_EWAY_KEY;
export const WP_MEDIA_BASE_URL = process.env.GATSBY_WP_MEDIA_BASE_URL;
export const IMGIX_BASE_URL = process.env.GATSBY_IMGIX_BASE_URL;